export default __webpack_public_path__ + "static/media/desktop-feature-1.1b43db6e.png";